import { useCallback, useEffect, useRef, useState } from "react";
import { useConversationsApi } from "../api/conversationsApi";

// Painel operacional: o valor está em refletir o agora, então ele se atualiza
// sozinho em vez de depender de alguém apertar recarregar.
export function useActiveService(hours = 24, { pollMs = 60000 } = {}) {
  const api = useConversationsApi();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mounted = useRef(true);

  const fetchActive = useCallback(async () => {
    try {
      const result = await api.getActive(hours);
      if (!mounted.current) return;
      setData(result);
      setError(null);
    } catch (err) {
      if (mounted.current) setError(err.message);
    } finally {
      if (mounted.current) setLoading(false);
    }
  }, [api, hours]);

  useEffect(() => {
    mounted.current = true;
    fetchActive();

    if (!pollMs) return undefined;

    const timer = setInterval(fetchActive, pollMs);
    return () => {
      mounted.current = false;
      clearInterval(timer);
    };
  }, [fetchActive, pollMs]);

  return { data, loading, error, refetch: fetchActive };
}
